import { useDispatch } from "react-redux";
import React, { useState } from "react";
import { instanceAction } from "../../../Redux/api";
import Modal from "../../utils/customModal";
import DinamicTable from "../../shared/table";
import {
  loadingHtml,
  errorContainer,
  sucessInfoModal,
} from "../../utils/functions";

import IconShow from "canvas-core-react/lib/IconShow";
import IconRedo from "canvas-core-react/lib/IconRedo";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import { useTranslation } from "react-i18next";

const defaultModal = { show: false, content: null, onClose: undefined };

const TableUsersByProvider = (props) => {
  const [state, setState] = useState({
    page: 0,
    sizePerPage: props.sizePerPage,
  });

  const [menus, setMenus] = useState(null);
  const [modal, setModal] = useState(defaultModal);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const closeModal = () => setModal(defaultModal);

  const handleTableChange = async ({
    page,
    sizePerPage,
    sort = "",
    property = "",
  }) => {
    const { getUsersByInstitution, updateNavigation } = props;

    let filters =
      property !== "" && property !== null
        ? [{ property: "sort", value: `${property},${sort}` }]
        : [];

    filters.push({ property: "user.userType.id", operator: "not", value: "2" });

    try {
      await dispatch(
        getUsersByInstitution(props.institutionId, page, sizePerPage, filters)
      );
      setState({ page, sizePerPage, order: sort, sortBy: property });
      updateNavigation({ page, sizePerPage });
    } catch (error) {
      console.log(error);
    }
  };

  const pendingForApprovals = () => {
    const { page, sizePerPage } = state;
    handleTableChange({ page, sizePerPage });
  };

  const resetCredentialsFunction = async (id, codUser) => {
    handleMenu(id, false);
    setModal({ content: loadingHtml(), show: true, onClose: undefined });

    let content;
    try {
      await dispatch(
        instanceAction(`users/update-for-recover-credentials`, "put", {
          idUser: codUser,
        })
      );

      content = sucessInfoModal(
        "Reseteo de credenciales",
        "¡Las credenciales han sido cambiadas!",
        { formBtn: { text: "Aceptar", action: closeModal } }
      );

      pendingForApprovals();
    } catch (err) {
      if (
        err.response !== undefined &&
        Array.isArray(err.response.data.notifications)
      ) {
        const notification = err.response.data.notifications[0];
        content = errorContainer(
          notification.message,
          notification.description,
          { continueBtn: { action: closeModal, text: "Aceptar" } }
        );
      }
    }
    setModal({ content, onClose: closeModal, show: true });
  };

  const handleMenu = (id, open) => {
    setMenus(open ? id : null);
  };

  const getTableColumns = () => {
    const getName = (name) =>
      t(`general.provider_account_detail.users.${name}`);

    return [
      {
        selector: "codUser",
        name: getName("cod_user"),
      },
      {
        selector: "userName",
        name: getName("user_name"),
      },
      {
        selector: "id",
        name: getName("id"),
      },
      {
        selector: "auth_code",
        name: getName("auth_code"),
      },
      {
        selector: "action",
        name: t("logs.detail.table.action"),
        cellFormatter: (row) => {
          if (row.obj.status === "TRANSITORY") {
            return
          } else {
            return (

              <ActionMenuList
                dialogPosition="bottom-right"
                iconType="horizontal-small"
                bottomSheet={{
                  heading: "Actions",
                  secondaryAction: {
                    onClick: () => { },
                    label: "Cancel",
                  },
                }}
                isMenuOpen={menus === row.userId}
                setIsMenuOpen={(open) => handleMenu(row.userId, open)}
              >
                {getMenuItems(row).map((element) => element)}
              </ActionMenuList>
            )
          }
        },
      },
    ];
  };

  const getMenuItems = (row) => {
    let items = [];
    items.push(
      <ActionMenuListItem
        icon={() => <IconShow className="TextButton__icon--left" />}
        onClick={() => {
          setMenus([]);
          getDetail(row);
        }}
      >
        {t("detail")}
      </ActionMenuListItem>
    );
    if (row.obj.authorizationCode) {
      items.push(
        <ActionMenuListItem
          icon={() => <IconRedo className="TextButton__icon--left" />}
          onClick={() => resetCredentialsFunction(row.userId, row.obj.id)}
        >
          {t("retrieveCredentials")}
        </ActionMenuListItem>
      );
    }

    return items;
  };

  const getDetail = (row) => {
    setTimeout(() => props.getDetailUser(row.obj), 0);
  };

  const setTableData = () => {
    return props.data?.map((item) => ({
      userId: item.id,
      codUser: item.codUser,
      userName: `${item.firstName} ${item.lastName}`,
      id: item.identification,
      auth_code:
        item.authorizationCode === null
          ? "No necesita"
          : item.authorizationCode,
      obj: item,
    }));
  };

  return (
    <>
      <DinamicTable
        headers={getTableColumns()}
        data={setTableData()}
        page={state.page}
        totalSize={props.totalSize}
        sizePerPage={state.sizePerPage}
        onTableChange={handleTableChange}
      />
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </>
  );
};

export default TableUsersByProvider;
